import { useEffect } from 'react'
import { useSearchParams } from 'react-router'
import { Loader2 } from 'lucide-react'
import { localeDArrivee } from '@/lib/locales'

/**
 * Pont pour /auth/callback (sans préfixe locale) : Google peut renvoyer ici si
 * le redirect URI n'inclut pas de locale. On lit la locale préférée puis on
 * redirige vers /:locale/auth/callback?... en conservant les query params.
 */
export function OAuthCallbackBridge() {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const locale = localeDArrivee()
    const qs = searchParams.toString()
    window.location.replace(`/${locale}/auth/callback${qs ? `?${qs}` : ''}`)
  }, [searchParams])

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A192F] text-white">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4" />
        <p className="text-white/80">Redirection…</p>
      </div>
    </div>
  )
}
